import { __, invertObj, prop } from 'ramda';

import { DocumentType } from '../../../types/document';

enum PrismicDocumentType {
  AGENDA = 'agenda',
  ARTICLE = 'article_v2',
  BRANCH_ACTIVITIES = 'branch_activities',
  MEDIA_PRESS = 'media_presse_v2',
  CONTACT = 'contact',
  CONTACT_PAGE = 'contact_page',
  FINANCIAL_DEBT = 'financial_debt',
  FINANCIAL_KEY_FIGURES = 'financial_key_figures',
  FINANCIAL_PRESS_RELEASE = 'financial_press_release',
  FINANCIAL_PUBLICATION = 'financial_publication',
  FINANCIAL_RATING = 'financial_rating',
  FOOTER = 'footer',
  GROUP_HISTORY = 'group_history',
  HEADER = 'header',
  HOME = 'home_page',
  HUB_ACTUS = 'hub_actus',
  INNOVATION_BY_LA_POSTE = 'innovation_by_la_poste_v2',
  LA_POSTE_EN_4 = 'la_poste_en_4',
  NEWSROOM = 'newsroom',
  GOUVERNANCE = 'organigramme',
  OUR_BRANDS = 'our_brands',
  PUBLIC_SERVICE_MISSIONS = 'public_service_missions',
  POSTMEN = 'postmen',
  REWARDED_INNOVATION_PAGE = 'rewarded_innovation_page',
  REWARDED_INNOVATION = 'rewarded_innovation',
  SEARCH_PAGE = 'search_page',
}

const PRISMIC_TO_TYPE_DOCUMENT = {
  [PrismicDocumentType.AGENDA]: DocumentType.AGENDA,
  [PrismicDocumentType.ARTICLE]: DocumentType.ARTICLE,
  [PrismicDocumentType.BRANCH_ACTIVITIES]: DocumentType.BRANCH_ACTIVITIES,
  [PrismicDocumentType.MEDIA_PRESS]: DocumentType.MEDIA_PRESS,
  [PrismicDocumentType.CONTACT]: DocumentType.CONTACT,
  [PrismicDocumentType.CONTACT_PAGE]: DocumentType.CONTACT_PAGE,
  [PrismicDocumentType.FINANCIAL_DEBT]: DocumentType.FINANCIAL_DEBT,
  [PrismicDocumentType.FINANCIAL_KEY_FIGURES]:
    DocumentType.FINANCIAL_KEY_FIGURES,
  [PrismicDocumentType.FINANCIAL_PRESS_RELEASE]:
    DocumentType.FINANCIAL_PRESS_RELEASE,
  [PrismicDocumentType.FINANCIAL_PUBLICATION]:
    DocumentType.FINANCIAL_PUBLICATION,
  [PrismicDocumentType.FINANCIAL_RATING]: DocumentType.FINANCIAL_RATING,
  [PrismicDocumentType.FOOTER]: DocumentType.FOOTER,
  [PrismicDocumentType.GROUP_HISTORY]: DocumentType.GROUP_HISTORY,
  [PrismicDocumentType.HEADER]: DocumentType.HEADER,
  [PrismicDocumentType.HOME]: DocumentType.HOME,
  [PrismicDocumentType.HUB_ACTUS]: DocumentType.HUB_ACTUS,
  [PrismicDocumentType.INNOVATION_BY_LA_POSTE]:
    DocumentType.INNOVATION_BY_LA_POSTE,
  [PrismicDocumentType.LA_POSTE_EN_4]: DocumentType.LA_POSTE_EN_4,
  [PrismicDocumentType.NEWSROOM]: DocumentType.NEWSROOM,
  [PrismicDocumentType.GOUVERNANCE]: DocumentType.GOUVERNANCE,
  [PrismicDocumentType.OUR_BRANDS]: DocumentType.OUR_BRANDS,
  [PrismicDocumentType.PUBLIC_SERVICE_MISSIONS]:
    DocumentType.PUBLIC_SERVICE_MISSIONS,
  [PrismicDocumentType.POSTMEN]: DocumentType.POSTMEN,
  [PrismicDocumentType.REWARDED_INNOVATION_PAGE]:
    DocumentType.REWARDED_INNOVATION_PAGE,
  [PrismicDocumentType.REWARDED_INNOVATION]: DocumentType.REWARDED_INNOVATION,
  [PrismicDocumentType.SEARCH_PAGE]: DocumentType.SEARCH_PAGE,
};

export const toDocType = prop(__, PRISMIC_TO_TYPE_DOCUMENT);
export const toDocPrismic = prop(__, invertObj(PRISMIC_TO_TYPE_DOCUMENT));
